import { useEffect, useRef, useState } from "react";

/**
 * Tracks whether the referenced element has scrolled near the viewport,
 * flipping to true once and staying true.
 *
 * @param {string} rootMargin
 * @returns {[import("react").RefObject, boolean]}
 */
export const useNearViewport = (rootMargin = "600px") => {
  const ref = useRef(null);
  const [isNear, setIsNear] = useState(false);

  useEffect(() => {
    if (!ref.current || typeof IntersectionObserver === "undefined") {
      setIsNear(true);
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsNear(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [rootMargin]);

  return [ref, isNear];
};
